﻿import {getBoxModelWithScroll} from "./BoxModel";

export type ScrollIntoViewMode = "automatic" | "top" | "bottom" | "middle";

export function scrollIntoView(root: HTMLElement, what: HTMLElement, mode: ScrollIntoViewMode, behavior: ScrollBehavior): void {
	const rootBBox = getBoxModelWithScroll(root).contentBox;
	const itemBBox = getBoxModelWithScroll(what).marginBox;

	const windowTop = rootBBox.top;
	const windowBottom = windowTop + rootBBox.height;

	const itemTop = itemBBox.top;
	const itemBottom = itemTop + itemBBox.height;
	let top = root.scrollTop;

	switch (mode) {
		case "automatic":
			if (itemBottom >= windowBottom) {
				top += Math.round(itemBottom - windowBottom);
			} else if (itemTop < windowTop) {
				top += Math.round(itemTop - windowTop);
			}

			break;

		case "top":
			top += Math.round(itemTop - windowTop);
			break;

		case "bottom":
			top += Math.round(itemBottom - windowBottom);
			break;

		case "middle":
			top += Math.round(itemTop - windowTop + itemBBox.height / 2 - rootBBox.height / 2);
			break;
	}

	root.scroll(
		{
			top: top,
			behavior: behavior
		});
}
